import React from 'react'
import ReactSVG from 'react-svg'

import Link from '../../Components/HeaderLink'
import TitleLogo from '../../Components/TitleLogo'
import Text from '../../Components/Text'


import './colsimg.css'


const ImgTextTwoCols = (({colTitle,bg_icon,icon,imgUrl,imgTitle,text,title,links,leftRight,bgColor})=>(
	<div className={bgColor}>
		<div>
			{title ? <TitleLogo className="title" title={title} /> : ''}
			<div className={title && title ? "cols" : ( !imgTitle && !imgTitle ? 'col--question' : '')}>
				
				<div className={leftRight === 'left' ? 'cols-flex img--left' : 'cols-flex img--right'}>
					<div className="col">
						{ imgTitle && imgTitle ? <div className="img__title"> { icon ? <i><ReactSVG path={icon} /></i> : ''} <b>{imgTitle}</b></div> : ''}
						<div className="img"><img src={imgUrl} alt={imgTitle} /></div>
					</div>
					<div className="col">
						{ colTitle && colTitle ? <div className="col__title">{colTitle}</div> : '' }
						{ !imgTitle && !imgTitle ? <div className="bg_icon"><img src={bg_icon} alt="icon" /></div> : '' }
						<Text text={text} />
						<div>
							{
								links.map((link,id)=>(
									<Link text={link.caption} url={link.url} target={link.target} className="btn btn--small" key={id} />
								))
							}
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
))

export default ImgTextTwoCols


// WEBPACK FOOTER //
// ./src/Containers/ImgTextTwoCols/index.js